import Util from 'util/util';

export default {
    isInApp() {
        return window.electronAPI?.isAvailable ?? false
    },

    canOpenInApp() {
        // show when user is in webapp on windows or macos (but not ipados)
        return !ISMOBILE && !this.isInApp() && (
            navigator.userAgent.includes('Windows') ||
            (navigator.userAgent.includes('Macintosh') && !Util.hasSupportForTouch())
        );
    },

    onClickOpenInApp(extraConfirmation = true) {
        const openApp = () => {
            jQuery.get({
                url: '/users/app_login_key',
                success: ({ app_login_key }) => {
                    const redirectPath = `learnbeat:///users/login_app/${app_login_key}/?go_to=${window.location.pathname}`;
                    window.location = redirectPath;
                },
                error: () => {
                    Backbone.View.layout.openStatus(
                        window.i18n.gettext('Something went wrong while opening the Learnbeat application.'),
                    );
                }
            });
        };

        if (!extraConfirmation) {
            openApp();
            return;
        }

        Backbone.View.layout.openConfirmStatus(
            window.i18n.gettext('Are you sure you want to open the Learnbeat app on your device?'),
            openApp
        );
    },

    openFocusModeActiveStatus(endTimestamp, alreadyInApp = false, elementCallback) {
        const currentTime = Date.now();
        const endTime = endTimestamp * 1000;
        const remainingTimeMs = endTime - currentTime;
        const remainingMinutes = Math.max(1, Math.round(remainingTimeMs / 60000));

        if (alreadyInApp) {
            Backbone.View.layout.openStatus(
                window.i18n.sprintf(
                    window.i18n.ngettext(
                        'Focus mode has been enabled by your teacher. It will be automatically deactivated in %s minute',
                        'Focus mode has been enabled by your teacher. It will be automatically deactivated in %s minutes',
                        remainingMinutes
                    ),
                    remainingMinutes
                ),
                'info',
                {
                    isFocusModeStatusMessage: true
                }
            );

            return;
        }

        if (remainingTimeMs > 0) {
            Backbone.View.layout.openStatus(
                window.i18n.gettext('Focus mode has been enabled by your teacher. Open the app to enter focus mode.'),
                'info',
                {
                    noHide: true,
                    mustReappear: true,
                    elementCallback,
                    buttonCallback: this.onCloseFocusModeStatusMessage.bind(this),
                    isFocusModeStatusMessage: true
                }
            );

            setTimeout(() => {
                if (Backbone.View.layout.getStatusMessage()?.extraOptions.isFocusModeStatusMessage) {
                    Backbone.View.layout.closeStatus();
                }
            }, remainingTimeMs);
        }
    },

    onCloseFocusModeStatusMessage(e) {
        e.stopPropagation()
        this.set('hasClosedFocusModeStatusMessage', true)
        Backbone.View.layout.closeStatus()
    },

    setFocusMode(activate = false) {
        window.electronAPI?.setFocusMode(activate)
    },

    checkFocusMode() {
        return window.electronAPI?.inFocusMode()
    }
};
